import React from 'react';

import HotelErrorWrapper from '../../../components/Errors/HotelErrorWrapper';

import useLogout from '../../../hooks/useLogout';

import translate from '../../../i18n/translate';

/**
 * Page that shows error when there is a MISSING_HOTEL error
 *
 * @returns The component itself
 */
const MissingHotelPage = () => {
  const logout = useLogout();

  return (
    <HotelErrorWrapper
      actionButton={{
        onClick: logout,
        text: translate('GENERAL__BACK_TO_LOGIN'),
      }}
      description={translate('ERROR__MISSING_HOTEL__DESCRIPTION')}
      title={translate('GENERAL__OOPS')}
    />
  );
};

export default MissingHotelPage;
